import { LAYOUTS, ModalAlignmentEnum, } from '@voltmoney/types';
import { ROUTE } from '../../routes';
import { isMobile } from '../../configs/utils';
import { InputStateToken, StackWidth, WIDGET } from '@voltmoney/schema';
import { ACTION } from "./types";
import { closeModal, closeParentModal, IFSCSearchAction, naviagteToIfscSection, validateBank, validateGst, validateIfsc, validatePan } from './action';
import { api } from '../../configs/api';
import { getAppHeader } from '../../configs/config';
import { heightMap } from '../../configs/height';
const _isMobile = isMobile();
export const template = async (height, bankDetail, panType, panNumber, gstNumber, bankAccountNumber, ifscCode) => {
    return ({
        layout: {
            id: ROUTE.PAYOUT_DETAILS_SCREEN,
            type: _isMobile ? LAYOUTS.LIST : LAYOUTS.MODAL,
            style: _isMobile ? {
                isPartnerPlatform: true,
            } : {
                //@ts-ignore
                isPartnerPlatform: true,
                height: heightMap[ROUTE.PAYOUT_DETAILS_SCREEN],
                alignment: ModalAlignmentEnum.RIGHT
            },
            widgets: [
                {
                    id: 'payoutDetailsScreen',
                    type: WIDGET.PAYOUT_DETAILS_PAGE,
                },
            ]
        },
        datastore: {
            payoutDetailsScreen: {
                height,
                width: StackWidth.MATCH_PARENT,
                bankDetail: bankDetail,
                panState: InputStateToken.DEFAULT,
                gstState: InputStateToken.DISABLED,
                ifscState: InputStateToken.DEFAULT,
                showErrorModal: false,
                showSuccessModal: false,
                showPennyModal: false,
                errorHeading: '',
                modalHeight: 192,
                message: '',
                selectedPanType: panType,
                selectedPanNumber: panNumber,
                selectedGstNumber: gstNumber,
                selectedBankAccountNumber: bankAccountNumber,
                selectedIfscCode: ifscCode,
                arnState: '',
                bankData: [],
                closeAction: {
                    type: ACTION.CLOSE_PARENT_MODAL,
                    routeId: ROUTE.PAYOUT_DETAILS_SCREEN,
                    payload: {}
                },
                closeModalAction: {
                    type: ACTION.CLOSE_MODAL,
                    routeId: ROUTE.PAYOUT_DETAILS_SCREEN,
                    payload: {}
                },
                validatebank: {
                    type: ACTION.VALIDATE_BANK,
                    routeId: ROUTE.PAYOUT_DETAILS_SCREEN,
                    payload: {}
                },
                navigateIfscSection: {
                    type: ACTION.NAVIGATE_IFSC,
                    routeId: ROUTE.PAYOUT_DETAILS_SCREEN,
                    payload: {}
                },
                panValidateAction: {
                    type: ACTION.VALIDATE_PAN,
                    routeId: ROUTE.PAYOUT_DETAILS_SCREEN,
                    payload: {}
                },
                gstValidateAction: {
                    type: ACTION.VALIDATE_GST,
                    routeId: ROUTE.PAYOUT_DETAILS_SCREEN,
                    payload: {}
                },
                ifscValidateAction: {
                    type: ACTION.VALIDATE_IFSC,
                    routeId: ROUTE.PAYOUT_DETAILS_SCREEN,
                    payload: {}
                },
                ifscAction: {
                    type: ACTION.SEARCH_IFSC_ACTION,
                    routeId: ROUTE.PAYOUT_DETAILS_SCREEN,
                    payload: {},
                },
            },
        },
    });
};
export const payoutDetailsScreen = {
    onLoad: async ({ network, asyncStorage, getHeight }, { panType, panNumber, gstNumber, bankAccountNumber, ifscCode }) => {
        const response = await network.get(api.banks, {
            headers: await getAppHeader(),
        });
        const bankResponse = response.data;
        const bankDetail = [
            ...Object.keys(bankResponse.ALLBANKS).sort().map((key) => ({
                label: bankResponse.ALLBANKS[key],
                value: key
            })),
        ];
        return Promise.resolve(template(getHeight(), bankDetail, panType, panNumber, gstNumber, bankAccountNumber, ifscCode));
    },
    actions: {
        [ACTION.CLOSE_PARENT_MODAL]: closeParentModal,
        [ACTION.CLOSE_MODAL]: closeModal,
        [ACTION.VALIDATE_BANK]: validateBank,
        [ACTION.NAVIGATE_IFSC]: naviagteToIfscSection,
        [ACTION.VALIDATE_PAN]: validatePan,
        [ACTION.VALIDATE_GST]: validateGst,
        [ACTION.VALIDATE_IFSC]: validateIfsc,
        [ACTION.SEARCH_IFSC_ACTION]: IFSCSearchAction,
    },
};
